import { render, staticRenderFns } from "./PaddockSingle.vue?vue&type=template&id=50027a46"
import script from "./PaddockSingle.vue?vue&type=script&lang=js"
export * from "./PaddockSingle.vue?vue&type=script&lang=js"
import style0 from "./PaddockSingle.vue?vue&type=style&index=0&id=50027a46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/home/runner/work/platform/platform/packages/client/src/components/utils/loader/Loader.vue').default,Img: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/image/Img.vue').default,MapIcon: require('/home/runner/work/platform/platform/packages/client/src/components/elements/geo/map/marker/MapIcon.vue').default,Heading: require('/home/runner/work/platform/platform/packages/client/src/components/elements/typography/heading/Heading.vue').default,Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default,PaddockNearest: require('/home/runner/work/platform/platform/packages/client/src/components/elements/paddocks/paddock-single/PaddockNearest.vue').default,Link: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/link/Link.vue').default,MapDirections: require('/home/runner/work/platform/platform/packages/client/src/components/elements/geo/map/directions/MapDirections.vue').default,BannerAdvert: require('/home/runner/work/platform/platform/packages/client/src/components/banners/BannerAdvert.vue').default,Currency: require('/home/runner/work/platform/platform/packages/client/src/components/elements/financial/currency-display/Currency.vue').default})
